import { useState } from "react";
import "./SeeMoreCell.css";

import SeeMoreButton from "../../../assets/SeeMoreButton.svg";



export type ActionCellProps = {
  onClicked: () => void;
};

const SeeMoreCell: React.FC<ActionCellProps> = ({ onClicked }) => {

  return (
    <div className="see-more-button">
      <div className="cell-unit">
        <div className="overlay"></div>

        <button
          onClick={() => {
            onClicked();
          }}
          className="cell-action-button"
        >             
          <>
            <div className="content">
              <div className="icon">
                <div className="action-overlay">
                  <img alt="cell action icon" src={SeeMoreButton} className="icon"></img>
                  <span className="body-medium">See More</span>
                </div>
              </div>
            </div>
          </>
          
        </button>
      </div>
    </div>
  );
};

export default SeeMoreCell;
